import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Information = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 Z M13,11 L11,11 L11,17 L13,17 L13,11 Z M13,7 L11,7 L11,9 L13,9 L13,7 Z" })));
};
export default Information;
